import React from "react";
import {
  Box,
  CarSideIcon,
  ChartPieIcon,
  ChatBubbleLeftRightIcon,
  ClockIcon,
  Cog8ToothIcon,
  GlobeAltIcon,
  MegaphoneIcon,
  PhoneIcon,
  TagIcon,
  UserIcon,
  UsersIcon
} from "@dealer-center/core-components";
import { ICON_BOX_STYLES } from "../styleConstants";
import { ReceiptTextIcon } from "./icons/ReceiptTextIcon";

// Map Material Icon names to Interstate icon components
const ICON_MAP: Record<string, React.ComponentType<any>> = {
  textsms: ChatBubbleLeftRightIcon,
  phonelink: GlobeAltIcon,
  directions_car: CarSideIcon,
  contact_mail: UsersIcon,
  settings_applications: Cog8ToothIcon,
  car_tag: TagIcon,
  photo_size_select_large: MegaphoneIcon,
  timeline: ChartPieIcon,
  phone: PhoneIcon,
  headphones: UserIcon,
  schedule: ClockIcon,
  receipt_long: ReceiptTextIcon
};

/**
 * Icons drawn with strokes rather than fills. The `& svg path` rule below whites out fill-based
 * Interstate glyphs, which would turn a `fill="none"` outline into a solid blob — so for these keys
 * the fill is neutralised to `none` instead, and the stroke picks up the wrapper's `color: white`
 * via `currentColor`. Any key not listed here takes the fill treatment.
 */
const STROKE_ICON_KEYS = new Set(["receipt_long"]);

interface CardIconProps {
  iconKey: string;
  iconColor: string;
  title?: string;
  iconSize?: string;
}

export const CardIcon: React.FC<CardIconProps> = ({
  iconKey,
  iconColor,
  title,
  iconSize = "20px"
}) => {
  const IconComponent = ICON_MAP[iconKey];
  const isStrokeIcon = STROKE_ICON_KEYS.has(iconKey);

  if (!IconComponent) {
    return null;
  }

  return (
    <Box
      className="application-icon"
      sx={{
        ...ICON_BOX_STYLES.base,
        backgroundColor: iconColor,
        pointerEvents: "none",
        "& svg": { color: "white !important" },
        "& svg path": {
          fill: isStrokeIcon ? "none !important" : "white !important"
        },
        "& svg circle": { fill: "white !important" },
        "& svg rect": { fill: "white !important" }
      }}
    >
      <IconComponent
        style={{
          fontSize: iconSize,
          lineHeight: "30px",
          color: "white"
        }}
        title={title}
      />
    </Box>
  );
};
